module.exports = __webpack_public_path__ + "img/royal.373ca81c.jpg";